import React from "react";
import { Card, Table, Layout, Space, Divider, Button, Radio } from "antd";
import { fmtDateTime } from "../../common/Utils";
import { Toolbar } from "../../components/Toolbar";
import { UserLink } from "../../components/UserLink/UserLink";
import { useReports } from "../../hooks/feedback/useReports";
import { FiltersBar } from "../../components/filter/FiltersBar";

export const Reports = () => {
  const { data, loading, filters, pagination, onSearch, refresh, reset, onPending, accept, reject, setFilters } =
    useReports();

  const columns = [
    { title: "", key: "i", render: (t, r, i) => i + 1 },
    {
      title: "User",
      dataIndex: ["user", "name"],
      render: (_, r) => <UserLink userId={r.user.id} name={r.user.name} fullName={r.user.name} />,
    },
    {
      title: "Title",
      dataIndex: "title",
    },
    {
      title: "Content",
      dataIndex: "content",
    },
    {
      title: "Status",
      dataIndex: "state",
    },
    {
      title: "Report Date",
      dataIndex: "createDate",
      render: fmtDateTime,
    },
    {
      title: "Operator",
      dataIndex: ["operator", "name"],
    },
    {
      title: "Operation Date",
      dataIndex: "operationDate",
      render: fmtDateTime,
    },
    {
      title: "",
      render: (_, r) => (
        <Space size="small">
          <Button type="link" onClick={() => accept(r)}>
            Accept
          </Button>
          <Divider type="vertical" />
          <Button type="link" onClick={() => reject(r)}>
            Reject
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <Layout.Content className="padding24">
      <Toolbar>
        <Radio.Group size="large" value={filters.pending} onChange={(e) => onPending(e.target.value)}>
          <Radio.Button value={true}>Pending</Radio.Button>
          <Radio.Button value={false}>History</Radio.Button>
        </Radio.Group>
      </Toolbar>

      <FiltersBar
        filters={filters}
        cfg={{}}
        search={onSearch}
        refresh={refresh}
        reset={reset}
        setFilters={setFilters}
        actionsSpan={8}
      ></FiltersBar>

      <Card size="small">
        <Table
          size="small"
          pagination={pagination}
          loading={loading}
          rowKey="id"
          columns={columns}
          dataSource={data.items}
        />
      </Card>
    </Layout.Content>
  );
};
